import LightGallery from "lightgallery";
import LgVideo from "lightgallery/plugins/video";

window.LightGallery = LightGallery;
window.LgVideo = LgVideo;